export default JSON.parse(`__ENV_DATA__`);